import axios from "axios";

import jwtInterceptor from "@core/interceptors/jwt/jwtInterceptor";
import errorInterceptor from "@core/interceptors/error/errorInterceptor";
import authService from "app/services/authService/authService";

export default class ApiAkilcabService {
  constructor() {
    this._api = axios.create();
    this.url = process.env.REACT_APP_CUSTOM_AKILCAB_SERVER_API;

    authService.init();
    jwtInterceptor.checkAuthenticateOrCredentials();

    this._api.interceptors.request.use((request) =>
      jwtInterceptor.successRequest(request)
    );

    this._api.interceptors.response.use(
      (response) => response,
      (error) => errorInterceptor.intercept(error)
    );
  }

  /**
   * GET endpoint
   *
   * @param {*} endpoint
   * @param {*} params
   * @param {*} reqOpts
   */
  _get(endpoint, params, reqOpts) {
    if (!reqOpts) {
      reqOpts = {
        params: params,
      };
    }

    return this._api.get(this.url + "/" + endpoint, reqOpts);
  }

  /**
   * POST endpoint
   *
   * @param {*} endpoint
   * @param {*} body
   * @param {*} reqOpts
   */
  _post(endpoint, body, reqOpts) {
    return this._api.post(this.url + "/" + endpoint, body, reqOpts);
  }

  /**
   * PUT endpoint
   *
   * @param {*} endpoint
   * @param {*} body
   * @param {*} reqOpts
   */
  _put(endpoint, body, reqOpts) {
    return this._api.put(this.url + "/" + endpoint, body, reqOpts);
  }

  /**
   * PATCH endpoint
   *
   * @param {*} endpoint
   * @param {*} body
   * @param {*} reqOpts
   */
  _patch(endpoint, body, reqOpts) {
    return this._api.patch(this.url + "/" + endpoint, body, reqOpts);
  }

  /**
   * DELETE endpoint
   *
   * @param {*} endpoint
   * @param {*} reqOpts
   */
  _delete(endpoint, params, reqOpts) {
    if (!reqOpts) {
      reqOpts = {
        params: params,
      };
    }

    return this._api.delete(this.url + "/" + endpoint, reqOpts);
  }
}
